export const HdrType = {
    NONE: 'NONE',
    DOLBY_VISION: 'DOLBY_VISION',
    HDR10: 'HDR10',
};
